import { useApp } from '../lib/data/store';
import { useNav, type Tab } from '../lib/nav';

interface Item {
  tab: Tab;
  label: string;
  icon: string;
  roles?: ('canvasser' | 'coordinator' | 'admin')[];
}

const ITEMS: Item[] = [
  { tab: 'map', label: 'Map', icon: '🗺️' },
  { tab: 'coverage', label: 'Coverage', icon: '🧭' },
  { tab: 'search', label: 'Search', icon: '🔎' },
  { tab: 'coord', label: 'Coordinator', icon: '📊', roles: ['coordinator', 'admin'] },
  { tab: 'admin', label: 'Admin', icon: '⚙️', roles: ['admin'] },
];

export function TabBar() {
  const { tab, setTab } = useNav();
  const { profile } = useApp();
  const role = profile?.role ?? 'canvasser';
  const items = ITEMS.filter((i) => !i.roles || i.roles.includes(role));

  return (
    <nav className="tabbar" aria-label="Primary">
      {items.map((i) => (
        <button
          key={i.tab}
          className={tab === i.tab ? 'active' : ''}
          aria-current={tab === i.tab ? 'page' : undefined}
          onClick={() => setTab(i.tab)}
        >
          <span className="ic" aria-hidden>
            {i.icon}
          </span>
          {i.label}
        </button>
      ))}
    </nav>
  );
}
